<template>
  <div class="contest-row" @click="onClickRow">
    <div class="main">
      <div class="title">{{ title }}</div>
      <div class="free">{{ free }}</div>
    </div>
    <div class="sub">
      <div class="deadline">{{ `${$t('homePage.contest.deadline')}${deadline}` }}</div>
      <div class="remaining-days" :class="{ red: isDeadlineApproaching }">
        <span>{{ $t('homePage.contest.remaining') }}</span>
        <span class="bold">{{ remainingDays }}</span>
        <span>{{ $t('homePage.contest.days') }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import { format, differenceInDays } from "date-fns";

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    contest: Object as PropType<Contest>,
  },
  computed: {
    id() {
      const { contest } = this;
      return contest.id;
    },
    title() {
      const { contest } = this;
      return contest.contest;
    },
    free() {
      const { contest } = this;
      return contest.free;
    },
    deadline() {
      const { contest } = this;
      const { deadline } = contest;

      if (!deadline) return "-";

      return format(deadline, "YYYY/MM/DD");
    },
    remainingDays() {
      const { deadline } = this;

      if (!deadline) return "-";

      const currentDate = format(new Date(), "YYYY/MM/DD");

      return differenceInDays(deadline, currentDate);
    },
    award() {
      const { contest } = this;
      return contest.award;
    },
    content() {
      const { contest } = this;
      return contest.content;
    },
    homepage() {
      const { contest } = this;
      return contest.homepage;
    },
    isDeadlineApproaching() {
      const { remainingDays } = this;
      return typeof remainingDays === "number" && remainingDays <= 7;
    },
  },
  methods: {
    onClickRow() {
      const { $router, id } = this;
      $router.push({ name: "eventContestDetail", params: { id } });
    },
  },
});

interface Props {
  contest: Contest;
}

interface Data {}

interface Computed {
  id: string;
  title: string;
  free: string;
  deadline: string;
  remainingDays: number | string;
  award: string;
  content: string;
  homepage: string;
  isDeadlineApproaching: boolean;
}

interface Methods {
  onClickRow(): void;
}

type Contest = {
  [key: string]: any;
};
</script>

<style lang="scss" scoped>
.contest-row {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  background-color: var(--color-surface-base);
  padding: 10px;
  cursor: pointer;

  .main {
    flex-grow: 1;
    color: var(--color-text-normal);

    * {
      margin-bottom: 0.5em;

      /** 省略するスタイル */
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }

    *:last-of-type {
      margin-bottom: 0;
    }

    .title {
      font-weight: var(--font-weight-bold);
      font-size: var(--font-size-sm);
    }

    .free {
      -webkit-line-clamp: 2;
      font-size: var(--font-size-xs);
    }
  }

  .sub {
    box-sizing: border-box;
    background-color: var(--color-background-normal);
    border-radius: var(--radius-sm);
    text-align: center;
    padding: 5px;
    margin-left: 0.5em;
    color: var(--color-text-normal);

    .deadline {
      width: max-content;
      font-size: var(--font-size-xs);
    }

    .remaining-days {
      font-weight: var(--font-weight-bold);

      &.red {
        color: var(--color-warning);
      }

      .bold {
        font-size: 1.5em;
      }
    }
  }
}
</style>
